import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FaqWidget } from '../../models/dot-cms-uve-contentlet.model';
import { DotCmsUveFaqComponent } from '../dot-cms-uve-faq/dot-cms-uve-faq.component';

@Component({
  selector: 'custom-dotcms-uve-faq-widget',
  templateUrl: './dot-cms-uve-faq-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DotCmsUveFaqComponent],
})
export class DotcmsUveFaqWidgetComponent {
  contentlet = input.required<FaqWidget>();
}
